import { casingUtil } from '@/utils'

export const resolveCommentDown = casingUtil.snakeToCamel
